module.exports = __webpack_public_path__ + "static/fonts/kendoui.2d27c2b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/images/kendoui.woff?v=1.1
// module id = 1651
// module chunks = 28